<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <TopMenu @opensearch="showSearchPanel = true"/>


    <!-- Podstrony -->
    <router-view v-slot="{ Component }">
        <Suspense timeout="0">
            <!-- Default -->
            <template #default>
                <component :is="Component" />
            </template>

            <!-- Loading -->
            <template #fallback>
                <p class="p-10 text-center">Loading page…</p>
            </template>
        </Suspense>
    </router-view>

    <Footer/>

    <hr>
    <SearchPanel :open="showSearchPanel"  @close="showSearchPanel = false" class="z-40" />

    <hr>
    <div>
        <Modal class="z-50"/>
    </div>



    <hr>
    <div>
        <Notification/>
    </div>

    <BottomBar />

<!--    TESTS-->
<!--    <div class="text-center py-3">-->
<!--        <button @click="showNotification()" class="p-3 border border-indigo-600 rounded text-indigo-600">Show Notification</button>-->
<!--        <button @click="showModal()" class="p-3 border border-indigo-600 rounded text-indigo-600 ml-3">Show Modal</button>-->
<!--    </div>-->
<!--    TESTS END-->

</template>

<script>
import { ref } from 'vue'
import Footer from "./components/layout/Footer";
import TopMenu from "./components/layout/TopMenu";
import SearchPanel from "./components/search/SearchDialogWindow";
import Modal from "./components/notification/Modal";
import Notification from "./components/notification/Notification";
import BottomBar from './components/notification/BottomBar.vue';
import PageHeading from "./components/layout/PageHeading";

export default {
    components: {
        PageHeading,
        BottomBar,
        Notification,
        Modal,
        SearchPanel,
        TopMenu,
        Footer,
    },
    setup() {
        const showSearchPanel = ref(false);

        return {
            showSearchPanel
        }
    },
    mounted() {
        if (localStorage.getItem('isAdult') !== 'yes') {
            this.emitter.emit('modal', {
                title: 'Czy masz ukończone 18 lat?',
                message: 'Produkty prezentowane w sklepie mogą być przeznaczone dla osób dorosłych.',
                type: 'info',
                confirmationLabel: 'Tak',
                cancelLabel: 'Nie',
                onConfirmation: 'isAdult',
                onCancel: 'isNotAdult',
            });
            this.emitter.on('isAdult', () => {
                localStorage.setItem('isAdult', 'yes');
            })
            this.emitter.on('isNotAdult', () => {
                window.location.href = 'https://search.brave.com/'
            })
        }
    },
    methods: {
        showNotification() {
            this.emitter.emit("notification", {
                title: 'Successfully saved!',
                message: 'Anyone with a link can now view this file.',
                type: 'success' // Do wyboru info, success, warning, error
            });
        },
        showModal() {
            this.emitter.emit("modal", {
                title: 'Successfully saved!',
                message: 'Anyone with a link can now view this file.',
                type: 'warning', // Do wyboru info, success, warning, error
                onConfirmation: 'modal-confirmed', // Tutaj podaj nazwę zdarzenia na kliknięcie przycisku potwierdzającego,
                onCancel: 'modal-canceled', // Tutaj podaj nazwę zdarzenia jakie będzie nasłuchiwane przy naciśnięciu cancel (opcjonalnie)
            });

            // Tutaj nasłuchuj odpowiedzi z modala:
            // akcja wykonywana na potwierdzenie
            this.emitter.on('modal-confirmed', (data) => {
                console.log('Potwierdzone');
                // Wyłacz nasłuchiwanie tego co ustawiłeś gdy już nie potrzebne:
                this.emitter.off('modal-confirmed')
                this.emitter.off('modal-canceled')
            });
            // akcja wykonywana na anulowanie (opcjonalnie)
            this.emitter.on('modal-canceled', (data) => {
                console.log('Anulowane');
                // Wyłacz nasłuchiwanie tego co ustawiłeś gdy już nie potrzebne:
                this.emitter.off('modal-confirmed')
                this.emitter.off('modal-canceled')
            });
        }
    }
}
</script>
